module.exports = __webpack_public_path__ + "img/dl-flowers.a05782d9.png";